<div class="main-page consultas">
  <div class="container-fluid">
    <!-- LINHA TITULO -->
    <div class="row align-items-center">
      <div class="col-12 my-2">
        <h1>Qual relatório você quer acessar?</h1>
      </div>
    </div>
    <!-- ITEM CARDS -->
    <div class="row mt-3">
      <div
        class="col-lg-4 my-2"
        *ngIf="
          this.permissionService.hasPermission(
            'JORNADA_RELATORIO_FUNCIONALIDADE',
            this.permissions
          )
        "
      >
        <a (click)="this.router.navigate(['/journey-control'])">
          <div class="card justify-content-center text-center">
            <div>
              <img src="assets/img/icons-page/jornada.svg" height="55" alt="" />
              <h5>Controle de Jornada</h5>
            </div>
          </div>
        </a>
      </div>
      <div
        class="col-lg-4 my-2"
        *ngIf="
          this.permissionService.hasPermission(
            'MOTORISTA_RELATORIO_FUNCIONALIDADE',
            this.permissions
          )
        "
      >
        <a (click)="this.router.navigate(['/driver-report'])">
          <div class="card justify-content-center text-center">
            <div>
              <img
                src="assets/img/icons-page/motorista.svg"
                height="55"
                alt=""
              />
              <h5>Relatório Operacional do Motorista</h5>
            </div>
          </div>
        </a>
      </div>
      <div
        class="col-lg-4 my-2"
        *ngIf="
          this.permissionService.hasPermission(
            'VEICULO_RELATORIO_FUNCIONALIDADE',
            this.permissions
          )
        "
      >
        <a (click)="this.router.navigate(['/vehicle-report'])">
          <div class="card justify-content-center text-center">
            <div>
              <img
                src="/assets/img/icons-page/veiculo.svg"
                height="55"
                alt=""
              />
              <h5>Relatório Operacional do Veículo</h5>
            </div>
          </div>
        </a>
      </div>
      <div
        class="col-lg-4 my-2"
        *ngIf="
          this.permissionService.hasPermission(
            'COMANDO_RELATORIO_FUNCIONALIDADE',
            this.permissions
          )
        "
      >
        <a (click)="this.router.navigate(['/command-report'])">
          <div class="card justify-content-center text-center">
            <div>
              <img
                src="assets/img/icons-page/processador.svg"
                height="55"
                alt=""
              />
              <h5>Relatório Envio Comandos</h5>
            </div>
          </div>
        </a>
      </div>
      <div
        class="col-lg-4 my-2"
        *ngIf="
          this.permissionService.hasPermission(
            'POSICOES_RELATORIO_FUNCIONALIDADE',
            this.permissions
          )
        "
      >
        <a (click)="this.router.navigate(['/stop-report'])">
          <div class="card justify-content-center text-center">
            <div>
              <img src="assets/img/icons-page/parada.svg" height="55" alt="" />
              <h5>Relatório de Posições</h5>
            </div>
          </div>
        </a>
      </div>
      <div
        class="col-lg-4 my-2"
        *ngIf="
          this.permissionService.hasPermission(
            'EVENTOS_RELATORIO_FUNCIONALIDADE',
            this.permissions
          )
        "
      >
        <a (click)="this.router.navigate(['/events-report'])">
          <div class="card justify-content-center text-center">
            <div>
              <img
                src="assets/img/icons-page/tratamentoeventos.svg"
                height="55"
                alt=""
              />
              <h5>Relatório Tratameto de Eventos</h5>
            </div>
          </div>
        </a>
      </div>
      <div
        class="col-lg-4 my-2"
        *ngIf="
          this.permissionService.hasPermission(
            'RELATORIOS_FUNCIONALIDADE',
            this.permissions
          )
        "
      >
        <a (click)="this.router.navigate(['/relatorios/create'])">
          <div class="card justify-content-center text-center">
            <div>
              <img src="assets/img/icons-page/report.svg" height="55" alt="" />
              <h5>Gerador de Relatórios</h5>
            </div>
          </div>
        </a>
      </div>

      <div
        class="col-lg-4 my-2"
        *ngIf="
          this.permissionService.hasPermission(
            'RELATORIOS_MOVIMENTO_FUNCIONALIDADE',
            this.permissions
          )
        "
      >
        <a (click)="this.router.navigate(['/ignition-report'])">
          <div class="card justify-content-center text-center">
            <div>
              <img src="assets/img/icons-page/ignicao.svg" height="55" alt="" />
              <h5>Tempo e Movimento</h5>
            </div>
          </div>
        </a>
      </div>

      <div
        class="col-lg-4 my-2"
        *ngIf="
          this.permissionService.hasPermission(
            'RELATORIOS_CERCA_FUNCIONALIDADE',
            this.permissions
          )
        "
      >
        <a (click)="this.router.navigate(['/cerca-eletronica'])">
          <div class="card justify-content-center text-center">
            <div>
              <img
                src="assets/img/icons-page/cerca-report.svg"
                height="55"
                alt=""
              />
              <h5>Entrada e Saída Cerca Eletrônica</h5>
            </div>
          </div>
        </a>
      </div>
      <div
        class="col-lg-4 my-2"
        *ngIf="
          this.permissionService.hasPermission(
            'RELATORIOS_CAMERA_FUNCIONALIDADE',
            this.permissions
          )
        "
      >
        <a (click)="this.router.navigate(['/video-photo-report'])">
          <div class="card justify-content-center text-center">
            <div>
              <img
                src="assets/img/icons-page/tracker-files.svg"
                height="55"
                alt=""
              />
              <h5>Relatório de Vídeos & Fotos</h5>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
